import * as angular from "angular";
import {IController, ILogService} from "angular";
import * as _ from "lodash";
import {LabelsService} from "../../../labels/services/labels-service.service";
import {
  DefaultPackageConfigurationFieldsType
} from "../../../site-preferences/types/default-package-configuration-fields.type";
import {PackageConfigurationService} from "../../../site-preferences/services/package-configuration-service.service";
import {SplitService} from "../../../commons/services/split-service.service";

export class OmsPackageListCtrl implements IController {

  packages: any;
  packageSizes: any;
  defaultItemSize: any;
  spotDimensions: any;
  spotWeight: number;
  isRequired: boolean;
  isTypeEnabled: boolean;
  isWeightInTotal: boolean;
  isShowSpots: boolean;
  isOmsPackageDimensionMandatory: boolean;
  onRemove: Function;
  onPackageChange: Function;

  public readonly defaultPackageConfigurationFieldsTypesMap: typeof DefaultPackageConfigurationFieldsType = DefaultPackageConfigurationFieldsType;

  private packageTypeSearchTerm: any;
  private sitePackageItemsMap: any;
  private packageTypeKeys: any;
  public packageTypeValues: any;
  private labelOptions: any;
  private weightConfig: any;
  private dimensionsConfig: any;
  public packagesOptionTypes: string[];
  public packageConfigurationByType: any;
  public packageConfigurationCustomFieldsByType: any;

  public packageCustomFieldsMap: any;

  // public packageConfigurationCustomFieldsByType: any;

  constructor(private orderConstants,
              private labelsService: LabelsService,
              private splitService: SplitService,
              private $log: ILogService,
              private packageConfigurationService: PackageConfigurationService) {
  }


  $onInit() {
    this.packageConfigurationByType = this.packageConfigurationService.getPackageConfigurationsBySize();
    this.packageConfigurationCustomFieldsByType = this.packageConfigurationService.getPackageConfigurationsCustomFieldsBySize();

    this.packageTypeSearchTerm = '';
    this.packageTypeKeys = {};
    this.labelOptions = [];
    this.sitePackageItemsMap = this.splitService.getSitePackageItemsMap();
    this.weightConfig = this.splitService.getWeightUnit();
    this.dimensionsConfig = this.splitService.getVolumeUnit();

    if (this.packageSizes && this.packageSizes.length) {
      this.packageTypeValues = _.map(this.packageSizes, (packageSize) => {
        return angular.copy(this.sitePackageItemsMap[packageSize.itemSize]) || {id: packageSize.itemSize};
      })
    }

    if (!this.labelOptions.length) {
      this.labelsService.getAll()
        .then((labels) => {
          this.labelOptions = labels;
        })
        .catch((error) => {
          this.$log.error('Failed to get Label options', error);
        })
    }
    if (!!_.get(this.packages, 'length') && !!this.spotDimensions) {
      _.forEach(this.packages, (p) => {
        if (!p.requiredSpots) {
          this._updatePackageRequiredSpots(p);
        }
      })
    }

    if (this.isWeightInTotal && this.packages?.length) {
      _.forEach(this.packages, (p) => {
        if (p.weight) {
          this._updatePackageTotalWeight(p);
        }
      })
    }

    this.packagesOptionTypes = [];
    this.packagesOptionTypes = _.map(this.packageSizes, (s) => {
      return s.itemSize;
    })

    this.setPackageCustomFieldsMap(this.packages);
  }

  $onChanges(changes) {
    if (changes.packages && !changes.packages.isFirstChange()) {
      const currenPackages = changes.packages.currentValue,
        previousPackages = changes.packages.previousValue;

      const packagesToAdd = _.difference(currenPackages, previousPackages);

      if (packagesToAdd.length) {
        _.forEach(packagesToAdd, (p) => {
          this._updatePackageRequiredSpots(p);
        })
      }

      this.setPackageCustomFieldsMap(this.packages);
    }
    if (changes.packageSizes && !changes.packageSizes.isFirstChange()) {
      this.$onInit();
    }
  };

  // onRemove(index) {
  //   this.packages.splice(index, 1);
  // }

  onCountChange(index, count) {
    this.packages[index].count = count;
    if (this.isWeightInTotal) {
      this._updatePackageWeight(this.packages[index]);
      this._updatePackageRequiredSpots(this.packages[index]);
    }
    this.onPackageChange({package: this.packages[index]});
  }

  onPackageTypeChange(item, selectedType) {
    if (item.type === selectedType) {
      return;
    }

    const packageObject = _.find(this.packageSizes, (ps) => {
      return ps.itemSize === selectedType;
    });

    let updatedItem: any = {
      id: item.id,
      count: item.count,
      type: selectedType,
    }

    if (packageObject) {
      updatedItem.labels = packageObject.labels;
      updatedItem.dimensions = packageObject.dimensions || {};
      updatedItem.weight = packageObject.weight;
    }

    if (this.packageConfigurationByType[selectedType][this.defaultPackageConfigurationFieldsTypesMap.Barcode] && !!item.barcode) {
      updatedItem.barcode = item.barcode;
    }

    this.onPackageChange({package: updatedItem});
  }

  onLabelChanges(labels, packageRef) {
    packageRef.labels = labels;
    this.onPackageChange({package: packageRef});
  }

  onChangeDimensions(packageItem) {
    this._updatePackageRequiredSpots(packageItem);
    this.onPackageChange({package: packageItem});
  }

  onTotalWeightChanged(packageItem) {
    this._updatePackageWeight(packageItem);
    this._updatePackageRequiredSpots(packageItem);
    this.onPackageChange({package: packageItem});
  }

  customFieldChange(updatedConfiguredField, item) {

    if (typeof item.configuredFields === "undefined" && updatedConfiguredField.value !== undefined) {
      item.configuredFields = [updatedConfiguredField];
    } else {
      const index = item.configuredFields?.findIndex(cf => cf.fieldName === updatedConfiguredField.fieldName);
      if (index !== -1) {
        item.configuredFields[index] = updatedConfiguredField;
      } else {
        item.configuredFields.push(updatedConfiguredField);
      }
    }

    // item.configuredFields[index] = updatedConfiguredField;
    this.onPackageChange({package: item});
  }


  // onChangeRequiredSpots(packageItem) {
  //   const requiredSpotsRef = _.get(packageItem, 'dimensions.requiredSpots', 1);
  //   packageItem.dimensions.height = 1;
  //   packageItem.dimensions.width = Math.floor(requiredSpotsRef / 2) * this.spotDimensions.width;
  //   packageItem.dimensions.length =  Math.floor(requiredSpotsRef / 2) * this.spotDimensions.length;
  //   // packageItem.dimensions.width = Math.ceil((requiredSpotsRef / 2) * (this.spotDimensions.width));
  //   // packageItem.dimensions.length = Math.ceil((requiredSpotsRef / 2) * this.spotDimensions.length);
  // }

  private _updatePackageRequiredSpots(packageItem) {
    const weightSpots = this.spotsByWeight(_.get(packageItem, 'weight', 0), this.spotWeight)

    const dimensionsSpots = this.spotsByDimensions(
      _.get(packageItem, 'dimensions.width', 0),
      this.spotDimensions.width,
      _.get(packageItem, 'dimensions.length', 0),
      this.spotDimensions.length);

    packageItem.requiredSpots = dimensionsSpots > weightSpots ? dimensionsSpots : weightSpots;
  }

  private spotsByDimensions(inputWidth, settingsWidth, inputLength, settingsLength): number {
    let dimensionsSpots = 0;

    if (settingsWidth && settingsLength) {
      const widthSpots = (inputWidth / settingsWidth) || 0;
      const LengthSpots = (inputLength / settingsLength) || 0;
      dimensionsSpots = Math.ceil(Math.ceil(widthSpots) * Math.ceil(LengthSpots));
    }
    return dimensionsSpots;
  }

  private spotsByWeight(inputWeight, settingsWeight): number {
    return settingsWeight ? Math.ceil(inputWeight / settingsWeight) : 0;
  }

  private _updatePackageTotalWeight(packageRef) {
    packageRef.totalWeight = packageRef.weight * packageRef.count;
  }

  private _updatePackageWeight(packageRef) {
    packageRef.weight = packageRef.totalWeight / packageRef.count;
  }

  private setPackageCustomFieldsMap(packages) {
    this.packageCustomFieldsMap = {}
    if (!packages || !packages.length) {
      return;
    }

    packages.forEach((p, i) => {
      if (p.configuredFields && p.configuredFields.length) {
        this.packageCustomFieldsMap[i] = {};

        p.configuredFields.forEach(cf => {
          this.packageCustomFieldsMap[i][cf.packageFieldId] = cf.value
        })

      }
    })

  }

}

angular
  .module('bringoz.admin.oms')
  .component('omsPackageList', {
    require: {
      form: '^form'
    },
    bindings: {
      packages: '<',
      packageSizes: '<?',
      defaultItemSize: '<?',
      spotDimensions: '<?',
      spotWeight: '<?',
      isShowSpots: '<?',
      isTypeEnabled: '<?',
      isRequired: '<',
      isWeightInTotal: '<?',
      isOmsPackageDimensionMandatory: '<?',
      onPackageChange: '&',
      onRemove: '&',
    },
    template: require('./oms-package-list.html').default,
    controller: OmsPackageListCtrl
  });
